module.exports = __webpack_public_path__ + "static/media/contest-dashboard-all-player.8ed80b66.png";